import React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Routes
} from "react-router-dom";
import { AuthError } from "../features/error";
import { MainPage } from "../features/main-page";
import { MainPageNLP } from "../features/MainPageNLP";
import { ChatPage } from "../features/chat-page";
import { ECChatPage } from "../features/ec-chat-page";
import { ECChatPageAgi } from "../features/ec-chat-page";
import { STTPage } from "../features/ec-chat-page";
import { STTSAPage } from "../features/ec-chat-page";
function PageRouting(){
    return (
        <>
        <Routes>
            <Route exact path="/" element={<MainPage />} />
            <Route exact path="/ent" element={<MainPage noheader = {false} />} />
            <Route exact path="/ent-noheader" element={<MainPage noheader = {true} />} />
            <Route exact path="/nlp" element={<MainPageNLP noheader = {false} />} />
            <Route exact path="/nlp-noheader" element={<MainPageNLP noheader = {true} />} />
            <Route exact path="/error" element={<AuthError />} />
            <Route exact path="/chat" element={<ChatPage />} />
            <Route exact path="/ec-chat" element={<ECChatPage />} />
            <Route exact path="/ec-chat-agi" element={<ECChatPageAgi />} />
            <Route exact path="/stt-poc" element={<STTPage />} />
            <Route exact path="/stt-sa" element={<STTSAPage />} />
        </Routes>
        </>
    )
}

export default PageRouting